module.exports = __webpack_public_path__ + "static/combine-campaigns-for-contests-8ad282a9deb22e1ad4aaab5d2e933fd8.svg";